<template lang="pug">
.user-team-full-select-card
  .user-team-full-select-card__title
    p {{mainTitle}}
    p {{secondTitle}}

  .user-team-full-select-card__value
    p {{mainValue}}
    p {{secondValue}}


</template>

<script>
export default {
  props: {
    id: {},
    mainTitle: {},
    mainValue: {},
    secondTitle: {},
    secondValue: {}
  }
};
</script>
